import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../service";
import {ICodeDescription} from "../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "./view-dictionary-base";

@Component({
  selector: 'app-dict-qref-codUch4077',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefCodUch4077ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-6 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         name="description"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="'description'"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.description }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
            {{ item.description }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefCodUch4077ViewComponent extends ViewDictionaryBase<ICodeDescription> {
  getDictionary = this.dictSrv.getQrefCodUch4077List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
